import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import type { ApplyTemplateMode } from './applyTemplateSnapshot';

export interface ApplyTemplateConfirmProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  templateName: string;
  /** Whether the template snapshot carries its own tax/markup/rounding. */
  templateHasRates: boolean;
  onApply: (mode: ApplyTemplateMode) => void;
}

// Only shown for a non-empty breakdown. Replace is the primary action: the flow
// that motivated this feature is duplicating a job, changing its project type,
// and wiping the now-stale inherited breakdown. Append covers building one
// breakdown out of several templates.
export function ApplyTemplateConfirm({
  open,
  onOpenChange,
  templateName,
  templateHasRates,
  onApply,
}: ApplyTemplateConfirmProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Apply "{templateName}"</DialogTitle>
          <DialogDescription>
            This breakdown already has line items. Replace them with the template, or
            append the template after them?
          </DialogDescription>
        </DialogHeader>
        <div className="py-2 space-y-2 text-sm text-gray-600">
          <p>
            <strong>Replace</strong> discards the current line items and projects.
            {templateHasRates && " It also applies the template's tax/markup and rounding."}
          </p>
          <p>
            <strong>Append</strong> keeps everything and adds the template below. This job
            keeps its own rates.
          </p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button variant="outline" onClick={() => onApply('append')}>
            Append
          </Button>
          <Button onClick={() => onApply('replace')}>Replace</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
